import { alpha, Box, Button, styled } from '@mui/material';

export const PreviewTriggerButton = styled(Button)({
  textTransform: 'none',
  borderRadius: '10px',
});

export const PreviewTableWrapper = styled(Box)(({ theme }) => ({
  margin: theme.spacing(2),
  borderRadius: '12px',
  border: '1px solid',
  borderColor: theme.palette.divider,
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper,
}));

export const PreviewTable = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '0.85rem',
  '& thead th': {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
    fontWeight: 600,
    fontSize: '0.72rem',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    padding: '10px 14px',
    borderBottom: '1px solid',
    borderColor: theme.palette.divider,
  },
  '& tbody td': {
    maxWidth: 320,
    padding: '8px 14px',
    color: theme.palette.text.primary,
    borderBottom: '1px solid',
    borderColor: theme.palette.divider,
  },
  '& tbody tr:last-of-type td': { borderBottom: 'none' },
  '& tbody tr:hover td': {
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
  },
}));
